const headers = [
  {
    text: 'storage.storage_register-date',
    value: 'stockAdjustDate',
    width: '100px'
  },
  {
    text: 'common.common_storage',
    value: 'storage.name',
    width: '100px'
  },
  {
    text: 'order.order_rep',
    value: 'userId',
    width: '100px'
  },
  {
    text: 'sale.sale_status',
    value: 'status'
  }
]

const tableKey = 'stockAdjustId'

const productListHeaders = [
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '20%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.input_supplier-name',
    value: 'supplier',
    sortable: false,
    width: '10%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'storage.storage_stock-adjustt-quantity-rack-number',
    value: 'quantityAndStorageNoForStockAdjust',
    sortable: false,
    width: '9%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'stock-adjust.stock-adjust_adjust-after-stock-cost',
    value: 'adjustAfterStockCost',
    sortable: false,
    width: '8%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

export default { headers, tableKey, productListHeaders }
